import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const StaffEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		employeeid: yup.string().required().label("Employeeid"),
		partnerid: yup.string().nullable().label("Partnerid"),
		userid: yup.string().required().label("Userid"),
		fullname: yup.string().required().label("Fullname"),
		email: yup.string().email().required().label("Email"),
		phonenumber: yup.string().required().label("Phonenumber"),
		address: yup.string().nullable().label("Address"),
		role: yup.string().required().label("Role"),
		department: yup.string().nullable().label("Department"),
		hiredate: yup.string().required().label("Hiredate"),
		status: yup.string().nullable().label("Status"),
		availabilitystatus: yup.string().nullable().label("Availabilitystatus"),
		currentlatitude: yup.number().nullable().label("Currentlatitude"),
		currentlongitude: yup.number().nullable().label("Currentlongitude"),
		vehicletype: yup.string().nullable().label("Vehicletype"),
		vehiclenumber: yup.string().nullable().label("Vehiclenumber"),
		salary: yup.number().nullable().label("Salary"),
		commissionrate: yup.number().nullable().label("Commissionrate"),
		createdat: yup.string().nullable().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	// form default values
	const formDefaultValues = {
		employeeid: '', 
		partnerid: '', 
		userid: '', 
		fullname: '', 
		email: '', 
		phonenumber: '', 
		address: '', 
		role: '', 
		department: '', 
		hiredate: new Date(), 
		status: "Active", 
		availabilitystatus: "Available", 
		currentlatitude: '', 
		currentlongitude: '', 
		vehicletype: '', 
		vehiclenumber: '', 
		salary: '', 
		commissionrate: '', 
		createdat: "(getdate())", 
		updatedat: "(getdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/staff`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="StaffEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Staff"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Employeeid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="employeeid"  onChange={formik.handleChange}  value={formik.values.employeeid}   label="Employeeid" type="text" placeholder="Enter Employeeid"        className={inputClassName(formik?.errors?.employeeid)} />
                                                <ErrorMessage name="employeeid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnerid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/partnerid_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="partnerid"     optionLabel="label" optionValue="value" value={formik.values.partnerid} onChange={formik.handleChange} options={response} label="Partnerid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.partnerid)}   />
                                                    <ErrorMessage name="partnerid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label="Userid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Fullname *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label="Fullname" type="text" placeholder="Enter Fullname"        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Email *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email"  onChange={formik.handleChange}  value={formik.values.email}   label="Email" type="email" placeholder="Enter Email"        className={inputClassName(formik?.errors?.email)} />
                                                <ErrorMessage name="email" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Phonenumber *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phonenumber"  onChange={formik.handleChange}  value={formik.values.phonenumber}   label="Phonenumber" type="text" placeholder="Enter Phonenumber"        className={inputClassName(formik?.errors?.phonenumber)} />
                                                <ErrorMessage name="phonenumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Address 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label="Address" type="text" placeholder="Enter Address"        className={inputClassName(formik?.errors?.address)} />
                                                <ErrorMessage name="address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Role *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="role"  onChange={formik.handleChange}  value={formik.values.role}   label="Role" type="text" placeholder="Enter Role"        className={inputClassName(formik?.errors?.role)} />
                                                <ErrorMessage name="role" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Department 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="department"  onChange={formik.handleChange}  value={formik.values.department}   label="Department" type="text" placeholder="Enter Department"        className={inputClassName(formik?.errors?.department)} />
                                                <ErrorMessage name="department" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Hiredate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="hiredate" showButtonBar className={inputClassName(formik?.errors?.hiredate)} dateFormat="yy-mm-dd" value={formik.values.hiredate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="hiredate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Availabilitystatus 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="availabilitystatus"  onChange={formik.handleChange}  value={formik.values.availabilitystatus}   label="Availabilitystatus" type="text" placeholder="Enter Availabilitystatus"        className={inputClassName(formik?.errors?.availabilitystatus)} />
                                                <ErrorMessage name="availabilitystatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Currentlatitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="currentlatitude"  onChange={formik.handleChange}  value={formik.values.currentlatitude}   label="Currentlatitude" type="number" placeholder="Enter Currentlatitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.currentlatitude)} />
                                                <ErrorMessage name="currentlatitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Currentlongitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="currentlongitude"  onChange={formik.handleChange}  value={formik.values.currentlongitude}   label="Currentlongitude" type="number" placeholder="Enter Currentlongitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.currentlongitude)} />
                                                <ErrorMessage name="currentlongitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Vehicletype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="vehicletype"  onChange={formik.handleChange}  value={formik.values.vehicletype}   label="Vehicletype" type="text" placeholder="Enter Vehicletype"        className={inputClassName(formik?.errors?.vehicletype)} />
                                                <ErrorMessage name="vehicletype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Vehiclenumber 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="vehiclenumber"  onChange={formik.handleChange}  value={formik.values.vehiclenumber}   label="Vehiclenumber" type="text" placeholder="Enter Vehiclenumber"        className={inputClassName(formik?.errors?.vehiclenumber)} />
                                                <ErrorMessage name="vehiclenumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Salary 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="salary"  onChange={formik.handleChange}  value={formik.values.salary}   label="Salary" type="number" placeholder="Enter Salary"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.salary)} />
                                                <ErrorMessage name="salary" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Commissionrate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="commissionrate"  onChange={formik.handleChange}  value={formik.values.commissionrate}   label="Commissionrate" type="number" placeholder="Enter Commissionrate"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.commissionrate)} />
                                                <ErrorMessage name="commissionrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
StaffEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'staff',
	apiPath: 'staff/edit',
	routeName: 'staffedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default StaffEditPage;
